import { Utils } from '@genial/utils';

import { DividendHistoryEntityNormalized, ReturnTypeOf_RendaVariavelObterProventos } from './types';

export const normalizeDividendHistory = (
  data: ReturnTypeOf_RendaVariavelObterProventos
): DividendHistoryEntityNormalized[] => {
  return data.map((item) => ({
    startDate: item.dtInicialPagamentoProventosOuNegociaoEx,
    startDateNormalized: Utils.Mask.DateFormat(
      item.dtInicialPagamentoProventosOuNegociaoEx,
      'dd/MM/yyyy'
    ),
    updateDate: item.dtPrevisaoPagamentoDividendos,
    updateDateNormalized: Utils.Mask.DateFormat(item.dtPrevisaoPagamentoDividendos, 'dd/MM/yyyy'),
    dueDate: item.dtPrazoFinal,
    dueDateNormalized: Utils.Mask.DateFormat(item.dtPrazoFinal, 'dd/MM/yyyy'),
    approvalDate: item.dtAprovacaoProvento,
    approvalDateNormalized: Utils.Mask.DateFormat(item.dtAprovacaoProvento, 'dd/MM/yyyy'),
    companyName: item.nmEmpresa,
    isinCode: item.cdIsinBase,
    dividendType: item.dsTpProvento,
    negotiationCode: item.cdNegociacaoBase,
    assetName: item.dsEspecificaoPapel,
    assetValue: item.vlProvento,
    assetValueNormalized: Utils.Mask.Money(item.vlProvento),
  }));
};
